"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoanRebalanced = void 0;
var PreludeCard_1 = require("../../prelude/PreludeCard");
var Resources_1 = require("../../../Resources");
var CardName_1 = require("../../../CardName");
var CardRenderer_1 = require("../../render/CardRenderer");
var LoanRebalanced = (function (_super) {
    __extends(LoanRebalanced, _super);
    function LoanRebalanced() {
        return _super.call(this, {
            name: CardName_1.CardName.LOAN_REBALANCED,
            metadata: {
                cardNumber: 'P17',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.minus().megacredits(2); }).br;
                    b.megacredits(32);
                }),
                description: 'Gain 32 M€. Decrease your M€ production 2 steps.',
            },
        }) || this;
    }
    LoanRebalanced.prototype.canPlay = function (player) {
        return player.getProduction(Resources_1.Resources.MEGACREDITS) >= -3;
    };
    LoanRebalanced.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.MEGACREDITS, -2);
        player.megaCredits += 32;
        return undefined;
    };
    return LoanRebalanced;
}(PreludeCard_1.PreludeCard));
exports.LoanRebalanced = LoanRebalanced;
//# sourceMappingURL=LoanRebalanced.js.map